import React, { useState } from "react";
import "../styles/Projects.css";
import lipicsy from "../images/Lipicsy.png";
import twitter from "../images/Twitter.png";
import bitvishwa from "../images/bitvishwa.png";
import netflix from "../images/netflix.png";
import whacmole from "../images/whacmole.png";
import calculator from "../images/calculator.png";
import vittbal from "../images/vittbal.webp";
import laxmint from "../images/laxmint.png";
import work from "../images/work.jpg";

const web2Projects = [
  {
    id: 1,
    image: lipicsy,
    title: "Lipicsy - Transform prompts into visuals",
    description:
      " Unleash your creativity as AI transforms prompts into captivating visuals. Explore endless possibilities by generating stunning content from prompts or discovering fresh ideas through the 'Surprise Me' feature.",
    techstack: "React JS,Tailwind CSS, Open AI",
    githubLink: "https://github.com/KeyurGK/LiPicsy",
    liveLink: "https://lipicsy.vercel.app/",
  },
  {
    id: 2,
    image: bitvishwa,
    title: "Bit Vishwa - Trending Crypto World Overview",
    description:
      " Discover trending cryptocurrencies through an interactive platform. Experience real-time INR prices of top 10 cryptos on a personalized dashboard, accessible after easy sign-up or login.",
    techstack: "React JS, Tailwind CSS, Firebase, API",
    githubLink: "https://github.com/KeyurGK/Bit-Vishwa",
    liveLink: "https://bitvishwa.vercel.app/",
  },
  {
    id: 3,
    image: twitter,
    title: "Twitter - Clone of X",
    description:
      "Seamlessly sign in with Google, compose and read tweets. Share images, browse a timeline of tweets, and experience the essence of social connection.",
    techstack: "React JS, Firebase",
    githubLink: "https://github.com/KeyurGK/twitter-clone",
    liveLink: "https://twitter-clone-keyurgk.vercel.app/",
  },
  {
    id: 4,
    image: netflix,
    title: "Netflix - Clone of Netflix",
    description:
      "Seamlessly sign in with Google, compose and read tweets. Share images, browse a timeline of tweets, and experience the essence of social connection.",
    techstack: "React JS, Firebase",
    githubLink: "https://github.com/KeyurGK/NETFLIX_clone",
    liveLink: "https://netflix-clone-keyurgk.vercel.app/",
  },
  {
    id: 5,
    image: whacmole,
    title: "Whac-A-Mole",
    description:
      "Seamlessly sign in with Google, compose and read tweets. Share images, browse a timeline of tweets, and experience the essence of social connection.",
    techstack: "HTML, CSS, JavaScript",
    githubLink: "https://github.com/KeyurGK/Whac_A_Mole",
    liveLink: "https://whac-a-mole-lilac.vercel.app/",
  },
  {
    id: 6,
    image: calculator,
    title: "Calculator",
    description:
      "Seamlessly sign in with Google, compose and read tweets. Share images, browse a timeline of tweets, and experience the essence of social connection.",
    techstack: "React JS",
    githubLink: "https://github.com/KeyurGK/Calculator",
    liveLink: "https://calculator-weld-xi.vercel.app/",
  },
];
const web3Projects = [
  {
    id: 1,
    image: vittbal,
    title: "VittBal",
    description:
      " Decentralized Balance Tracker on Sepolia testnet: Securely manage deposits, update balances, and view real-time account data via Metamask.",
    techstack: "Solidity, JavaScript",
    githubLink: "https://github.com/KeyurGK/Vittbal",
    liveLink: "https://vittbal.vercel.app/",
  },
  {
    id: 2,
    image: laxmint,
    title: "LaxMINT",
    description:
      " A user-friendly DApp for creating and minting custom ERC-20 tokens via Metamask, facilitating easy management and import into wallets.",
    techstack: "Solidity, JavaScript",
    githubLink: "https://github.com/KeyurGK/LaxMINT",
    liveLink: "https://laxmint.vercel.app/",
  },
  {
    id: 3,
    image: work,
    title: "⚒️⚒️",
    description: " In Progress",
    techstack: "",
    githubLink: "",
    liveLink: "",
  },

  {
    id: 4,
    image: work,
    title: "⚒️⚒️",
    description: " In Progress",
    techstack: "",
    githubLink: "",
    liveLink: "",
  },
  {
    id: 5,
    image: work,
    title: "⚒️⚒️",
    description: " In Progress",
    techstack: "",
    githubLink: "",
    liveLink: "",
  },
  {
    id: 6,
    image: work,
    title: "⚒️⚒️",
    description: " In Progress",
    techstack: "",
    githubLink: "",
    liveLink: "",
  },
];
const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [displayWeb2, setDisplayWeb2] = useState(true);

  const handleImageClick = (project) => {
    setSelectedProject(project);
  };
  const toggleDisplay = () => {
    setDisplayWeb2(!displayWeb2);
  };
  const projectsToDisplay = displayWeb2
    ? web2Projects.filter((project) => project.image !== null)
    : web3Projects.filter((project) => project.image !== null);
  // Divide the projects into two columns
  const projectsColumn1 = projectsToDisplay.slice(0, 3);
  const projectsColumn2 = projectsToDisplay.slice(3);

  return (
    <div className="projects">
      <h2>Proof of Work</h2>
      <div className="projects_type">
        <button
          onClick={() => {
            toggleDisplay();
            setDisplayWeb2(true);
          }}
          className={displayWeb2 ? "selected" : ""}
        >
          Web2
        </button>
        <button
          onClick={() => {
            toggleDisplay();
            setDisplayWeb2(false);
          }}
          className={!displayWeb2 ? "selected" : ""}
        >
          Web3
        </button>
      </div>
      <div className="projects_columns">
        <div className="projects_column">
          {projectsColumn1.map((project) => (
            <div
              key={project.id}
              className={`project-container ${
                selectedProject === project ? "selected" : ""
              }`}
              onClick={() => handleImageClick(project)}
            >
              {selectedProject === project ? (
                <div className="project_details">
                  <p>{project.description}</p>
                  <p>{project.techstack}</p>
                  <div className="project_details-buttons">
                    <button
                      onClick={() =>
                        (window.location.href = project.githubLink)
                      }
                    >
                      GitHub
                    </button>
                    <button
                      onClick={() => (window.location.href = project.liveLink)}
                    >
                      Live
                    </button>
                  </div>
                </div>
              ) : (
                <img
                  src={project.image}
                  alt={project.title}
                  className="projects_list-image"
                />
              )}
              <h4>{project.title}</h4>
            </div>
          ))}
        </div>
        <div className="projects_column">
          {projectsColumn2.map((project) => (
            <div
              key={project.id}
              className={`project-container ${
                selectedProject === project ? "selected" : ""
              }`}
              onClick={() => handleImageClick(project)}
            >
              {selectedProject === project ? (
                <div className="project_details">
                  <p>{project.description}</p>
                  <p>{project.techstack}</p>
                  <div className="project_details-buttons">
                    <button
                      onClick={() =>
                        (window.location.href = project.githubLink)
                      }
                    >
                      GitHub
                    </button>
                    <button
                      onClick={() => (window.location.href = project.liveLink)}
                    >
                      Live
                    </button>
                  </div>
                </div>
              ) : (
                <img
                  src={project.image}
                  alt={project.title}
                  className="projects_list-image"
                />
              )}
              <h4>{project.title}</h4>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
